import Alert from '@amzn/meridian/alert';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import ActionButton from './ActionButton';

interface CatalogJobFailureProps {
  catalogJobErrorMessage: string | null;
  isSubmitting: boolean;
  onRetry: () => void;
}

export default function CatalogJobFailure({ catalogJobErrorMessage, isSubmitting, onRetry }: CatalogJobFailureProps) {
  return (
    <Column spacing="200">
      <Alert type="error" size="medium">
        <Text type="b200" breakWord>
          {catalogJobErrorMessage || 'No failure reason was recorded for this job.'}
        </Text>
      </Alert>
      <Text type="b200" color="secondary">
        This catalog job failed. Retry, or contact the team if it keeps failing.
      </Text>
      <Row>
        <ActionButton variant="primary" onClick={onRetry} busy={isSubmitting} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Retry'}
        </ActionButton>
      </Row>
    </Column>
  );
}
